import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, finalize } from 'rxjs';

import { UtilisateursService } from '../../services/utilisateurs.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { ApprenantFode } from 'src/app/model/apprenantFode.model';
import { PaginatedResponse } from 'src/app/interfaces/paginateResponse.interface';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import {
  CertificationView,
  CourseType,
  EmailCertificationResponse,
  ModuleType
} from 'src/app/model/email-certification.model';
import { BackendApiService } from 'src/app/service/backend-api.service';



// TYPES

type StudentViewMode =
  | 'ALL'
  | 'FEMALE'
  | 'MALE'
  | 'CERTIFIED'
  | 'ENHANCED'
  | 'INSERES'
  | 'CERTIFICATE';

interface ExportCountry {
  name: string;
  isoCode?: string;
  isAll?: boolean;
}

interface ExportRegion {
  name: string;
  codeIso?: string;
  isoCode?: string;
  isAll?: boolean;
}




@Component({
  selector: 'app-apprenants',
  templateUrl: './apprenants.component.html',
  styleUrls: ['./apprenants.component.css']
})
export class ApprenantsComponent implements OnInit, AfterViewInit {


  // LISTE APPRENANTS
  size = 2000;
  page = 0;
  private filter = '';
  searchValue = '';

  allStudentsPage: ApprenantFode[] = [];
  students: ApprenantFode[] = [];
  dataSource = new MatTableDataSource<ApprenantFode>();

  totalElements = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 20, 30, 50, 100];

  @ViewChild(MatPaginator) paginator!: MatPaginator;



  // MODES
  viewMode: StudentViewMode = 'ALL';

  modeLabels: Record<StudentViewMode, string> = {
    ALL: 'Tous',
    FEMALE: 'Femmes',
    MALE: 'Hommes',
    CERTIFIED: 'Certifiés',
    ENHANCED: 'Renforcés',
    INSERES: 'En situation d\'emploi',
    CERTIFICATE: 'Par certificat'
  };



  // CERTIFICATS
  certifcateOption: any[] = [];
  selectedCertificateId: string | null = null;
  certificationData?: EmailCertificationResponse;
  certificationRows: CertificationView[] = [];
  courseTypeOptions = Object.values(CourseType);
  selectedCourseType: CourseType | null = null;

  // TABLE
  displayedColumns: string[] = ['name', 'sexe', 'email', 'action'];
  filtersOpen = true;
  activeFiltersCount = 0;
  isSearching = false;

  // POPUP
  popupVisible = false;
  ligneDetails: any;

  // BREADCRUMB
  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'FORMATION' },
    { label: 'APPRENANTS', url: '/dashboard/users/apprenants' }
  ];

  // EXPORT
  exportMenuOpen = false;
  exportLoading: 'normal' | 'distinct' | null = null;

  exportFlag: 'CERTIFIED' | 'ENHANCED' | 'INSERES' | null = null;
  exportGender: 'FEMALE' | 'MALE' | null = null;

  exportCourseType: string | null = null;
  exportLabel: string | null = null;
  exportAgeRange: string | null = null;
  exportStatus: string | null = null;

  //EXPORT COHORTE
  exportCohortes: string[] = [];
  filteredExportCohortes: string[] = [];
  exportCohorte: string | null = null;

  // EXPORT PAYS
  exportCountry: string | null = null;
  exportCountries: ExportCountry[] = [
    { name: 'Tous les pays', isAll: true },
    { name: 'Sénégal', isoCode: 'SN' },
    { name: 'Bénin', isoCode: 'BJ' }
  ];

  selectedExportCountry: ExportCountry = this.exportCountries[0];

  // EXPORT RÉGIONS
  loadingExportRegions = false;
  exportRegions: ExportRegion[] = [];
  exportRegionOptions: ExportRegion[] = [
    { name: 'Toutes les régions', isAll: true }
  ];

  selectedExportRegionOption: ExportRegion = this.exportRegionOptions[0];
  selectedExportRegion: ExportRegion | null = null;
  exportRegion: string | null = null;

  // EXPORT CERTIFICATS
  exportCertificateOptions: any[] = [];


  constructor(
    private utilisateurService: UtilisateursService,
    private spinnerService: SpinnerServiceService,
    private backendapiService: BackendApiService
  ) { }


  ngOnInit(): void {
    this.loadExportCohortes();
    this.loadStudents();
  }

  ngAfterViewInit(): void {
    this.paginator.page.subscribe((event: PageEvent) => {
      this.currentPage = event.pageIndex;
      this.pageSize = event.pageSize;
      this.loadStudents();
    });
  }


  // FILTRES
  toggleFilters(): void {
    this.filtersOpen = !this.filtersOpen;
  }

  resetFilters(): void {
    this.selectedCourseType = null;
    this.selectedCertificateId = null;
    this.certifcateOption = [];
    this.viewMode = 'ALL';
    this.searchValue = '';
    this.dataSource.filter = '';
    this.currentPage = 0;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.isSearching = false;
    this.updateActiveFiltersCount();
    this.loadStudents();
  }

  updateActiveFiltersCount(): void {
    this.activeFiltersCount =
      (this.viewMode !== 'ALL' ? 1 : 0) +
      (this.selectedCourseType ? 1 : 0) +
      (
        this.selectedCertificateId &&
          this.selectedCertificateId !== '-1'
          ? 1
          : 0
      );
  }

  // REQUEST APPRENANTS

  private buildRequest(
    page: number,
    size: number,
    search: string = ''
  ): Observable<PaginatedResponse<ApprenantFode>> | undefined {

    switch (this.viewMode) {
      case 'CERTIFIED':
        return this.utilisateurService.getStudentCertified(
          this.selectedCourseType,
          this.selectedCertificateId,
          page,
          size
        );

      case 'ENHANCED':
        return this.utilisateurService.getStudentEnhanced(
          this.selectedCourseType,
          this.selectedCertificateId,
          page,
          size
        );

      case 'INSERES':
        return this.utilisateurService.getStudentAipen(
          this.selectedCourseType,
          this.selectedCertificateId,
          page,
          size
        );

      case 'CERTIFICATE':
        if (!this.selectedCertificateId || !this.selectedCourseType) {
          return undefined;
        }

        return this.utilisateurService.getStudentsByCertificateId(
          this.selectedCertificateId,
          this.selectedCourseType,
          page,
          size
        );

      default:
        return this.utilisateurService.getListApprenantFromFode(
          page,
          size,
          search
        );
    }
  }


  // LOAD APPRENANTS
  loadStudents(): void {
    this.spinnerService.showSpinner();

    const request$ = this.buildRequest(
      this.currentPage,
      this.pageSize,
      this.viewMode === 'ALL' ? this.searchValue : ''
    );

    if (!request$) {
      this.spinnerService.hideSpinner();
      return;
    }

    request$.subscribe({
      next: (res: PaginatedResponse<ApprenantFode>) => {
        this.allStudentsPage = res.content;
        this.totalElements = res.totalElements;
        this.genderFilters();
        this.spinnerService.hideSpinner();
      },
      error: (error) => {
        console.error(
          'Erreur lors du chargement des apprenants :',
          error
        );
        this.spinnerService.hideSpinner();
      }
    });
  }

  // RECHERCHE
  private searchStudents(searchValue: string): void {
    this.spinnerService.showSpinner();
    this.searchValue = searchValue;

    const request$ = this.buildRequest(0, this.pageSize, searchValue);

    if (!request$) {
      this.spinnerService.hideSpinner();
      return;
    }

    request$.subscribe({
      next: (res: PaginatedResponse<ApprenantFode>) => {
        this.allStudentsPage = res.content;
        this.totalElements = res.totalElements;
        this.currentPage = 0;
        this.students = [...res.content];
        this.dataSource = new MatTableDataSource(this.students);
        this.spinnerService.hideSpinner();
      },
      error: (err) => {
        console.error('Erreur lors de la recherche :', err);
        this.spinnerService.hideSpinner();
      }
    });
  }



  // DETAILS
  openDetails(row: any): void {
    this.ligneDetails = row;
    this.popupVisible = true;
    this.loadCertifiableCourse(row.email);
  }

  closeModal(): void {
    this.popupVisible = false;
  }


  // MODE
  setMode(mode: StudentViewMode): void {
    this.viewMode = mode;

    if (mode === 'ALL' || mode === 'FEMALE' || mode === 'MALE') {
      this.selectedCourseType = null;
      this.selectedCertificateId = null;
      this.certifcateOption = [];
    }

    this.searchValue = '';
    this.dataSource.filter = '';
    this.currentPage = 0;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.isSearching = false;
    this.updateActiveFiltersCount();
    this.loadStudents();
  }

  // RECHERCHE TEXTE
  filterText(event: Event): void {
    if (this.viewMode !== 'ALL') {
      return;
    }

    const value = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    this.searchValue = value;
    this.currentPage = 0;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    if (!value) {
      this.isSearching = false;
      this.dataSource.filter = '';
      this.loadStudents();
      return;
    }

    this.isSearching = true;
    this.searchStudents(value);
  }

  // CERTIFICATION
  loadCertifiableCourse(email: string): void {
    this.spinnerService.showSpinner();

    this.utilisateurService.getCertifiableCourseByEmail(email).subscribe({
      next: (res) => {
        const grouped = new Map<string, CertificationView>();

        res.items.forEach(item => {
          const key = `${item.idCertificate}-${item.cohort}`;

          if (!grouped.has(key)) {
            grouped.set(key, {
              idCertificate: item.idCertificate,
              nameCertificate: item.nameCertificate,
              cohort: item.cohort,
              certified: false,
              enhanced: false,
              inserted: false
            });
          }

          const row = grouped.get(key)!;

          switch (item.typeModule) {
            case ModuleType.CERTIFIED:
              row.certified = true;
              break;

            case ModuleType.ENHANCED:
              row.enhanced = true;
              break;

            case ModuleType.INSERTED:
              row.inserted = true;
              break;
          }
        });

        this.certificationRows = Array.from(grouped.values());
        this.certificationData = res;
        this.spinnerService.hideSpinner();
      },
      error: (err) => {
        console.error(err);
        this.spinnerService.hideSpinner();
      }
    });
  }



  // GENRE
  genderFilters(): void {
    let data = [...this.allStudentsPage];

    if (this.viewMode === 'FEMALE') {
      data = data.filter(student => student.sexe === 'Femme');
    }

    if (this.viewMode === 'MALE') {
      data = data.filter(student => student.sexe === 'Homme');
    }

    this.students = data;
    this.dataSource = new MatTableDataSource(this.students);
  }


  // CERTIFICATS
  loadCertificates(): void {
    if (!this.selectedCourseType) {
      this.certifcateOption = [];
      return;
    }

    this.utilisateurService.getAllCertificate(this.selectedCourseType).subscribe({
      next: (res) => {
        this.certifcateOption = res;
      },
      error: (error) => {
        console.error(
          'Erreur lors du chargement des certificats :',
          error
        );
        this.certifcateOption = [];
      }
    });
  }

  onCertificateChange(): void {
    this.currentPage = 0;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.isSearching = false;

    if (
      !this.selectedCertificateId ||
      this.selectedCertificateId === '-1'
    ) {
      this.viewMode = 'ALL';
    } else {
      this.viewMode = 'CERTIFICATE';
    }

    this.updateActiveFiltersCount();
    this.loadStudents();
  }

  // TYPE DE PARCOURS
  onCourseTypeChange(): void {
    this.selectedCertificateId = null;
    this.certifcateOption = [];
    this.searchValue = '';
    this.dataSource.filter = '';
    this.currentPage = 0;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.isSearching = false;

    if (!this.selectedCourseType) {
      this.viewMode = 'ALL';
      this.updateActiveFiltersCount();
      this.loadStudents();
      return;
    }

    this.viewMode = 'ALL';
    this.updateActiveFiltersCount();
    this.loadCertificates();
  }



  // EXPORT - PAYS

  onExportCountrySelected(event: any): void {

    const country = event?.value as ExportCountry | null;

    if (!country) {
      return;
    }

    this.selectedExportCountry = country;

    this.exportCountry = country.isAll
      ? null
      : country.isoCode?.trim().toUpperCase() ?? null;

    // Réinitialiser la cohorte
    this.exportCohorte = null;

    this.filteredExportCohortes = [];

    // Tous les pays
    if (country.isAll || !country.isoCode) {

      console.log('Export - Tous les pays');

      return;
    }

    const isoCode = country.isoCode.trim().toUpperCase();

    // Filtrer les cohortes selon le pays
    if (isoCode === 'BJ') {

      // Bénin : uniquement les cohortes commençant par BENIN
      this.filteredExportCohortes = this.exportCohortes.filter(
        cohorte =>
          cohorte?.trim().toUpperCase().startsWith('BENIN')
      );

    } else if (isoCode === 'SN') {

      // Sénégal : toutes les cohortes sauf celles commençant par BENIN
      this.filteredExportCohortes = this.exportCohortes.filter(
        cohorte =>
          !cohorte?.trim().toUpperCase().startsWith('BENIN')
      );

    } else {

      // Autres pays
      this.filteredExportCohortes = [];
    }

    // Réinitialiser la région
    this.selectedExportRegion = null;

    this.exportRegion = null;

    this.exportRegions = [];

    this.exportRegionOptions = [
      {
        name: 'Toutes les régions',
        isAll: true
      }
    ];

    this.selectedExportRegionOption =
      this.exportRegionOptions[0];

    console.log('Export - Pays :', country.name);
    console.log('Export - Code ISO :', this.exportCountry);
    console.log(
      'Export - Cohortes disponibles :',
      this.filteredExportCohortes
    );

    this.loadExportRegions(country.isoCode);
  }
  // EXPORT - RÉGION
  loadExportRegions(isoCode: string): void {
    this.loadingExportRegions = true;

    const normalizedIsoCode = isoCode.trim().toUpperCase();

    this.backendapiService.getCities().subscribe({
      next: (regions: any[]) => {
        const seen = new Set<string>();

        this.exportRegions = regions
          .filter(region =>
            String(region.codeIso ?? '')
              .trim()
              .toUpperCase() === normalizedIsoCode
          )
          .filter(region => {
            const name = String(region.name ?? '').trim();
            const key = name.toLowerCase();

            if (!name || seen.has(key)) {
              return false;
            }

            seen.add(key);
            return true;
          })
          .map(region => ({
            ...region,
            isoCode: normalizedIsoCode
          }))
          .sort((a, b) =>
            a.name.localeCompare(b.name, 'fr', {
              sensitivity: 'base'
            })
          );

        this.exportRegionOptions = [
          {
            name: 'Toutes les régions',
            isoCode: normalizedIsoCode,
            isAll: true
          },
          ...this.exportRegions
        ];

        this.selectedExportRegionOption =
          this.exportRegionOptions[0];

        this.selectedExportRegion = null;
        this.exportRegion = null;
        this.loadingExportRegions = false;

        console.log(
          'Export - Régions trouvées :',
          this.exportRegions
        );
      },

      error: (error) => {
        console.error(
          'Erreur lors du chargement des régions :',
          error
        );

        this.exportRegions = [];

        this.exportRegionOptions = [
          {
            name: 'Toutes les régions',
            isoCode: normalizedIsoCode,
            isAll: true
          }
        ];

        this.selectedExportRegionOption =
          this.exportRegionOptions[0];

        this.selectedExportRegion = null;
        this.exportRegion = null;
        this.loadingExportRegions = false;
      }
    });
  }
  onExportRegionSelected(event: any): void {
    const region = event?.value as ExportRegion | null;

    if (!region) {
      return;
    }

    if (region.isAll) {
      this.selectedExportRegion = null;
      this.selectedExportRegionOption = region;
      this.exportRegion = null;

      console.log('Export - Toutes les régions');
      return;
    }

    this.selectedExportRegion = region;
    this.selectedExportRegionOption = region;
    this.exportRegion = region.name;

    console.log('Export - Région :', this.exportRegion);
  }

  // EXPORT - CLEAR PAYS
  clearExportCountry(): void {
    this.selectedExportCountry = this.exportCountries[0];
    this.exportCountry = null;

    this.selectedExportRegion = null;
    this.exportRegion = null;
    this.exportRegions = [];

    this.exportRegionOptions = [
      { name: 'Toutes les régions', isAll: true }
    ];

    this.selectedExportRegionOption = this.exportRegionOptions[0];
    this.loadingExportRegions = false;
  }

  // EXPORT - CLEAR RÉGION
  clearExportRegion(): void {
    this.selectedExportRegion = null;
    this.exportRegion = null;

    this.exportRegionOptions = [
      { name: 'Toutes les régions', isAll: true },
      ...this.exportRegions
    ];

    this.selectedExportRegionOption = this.exportRegionOptions[0];
  }

  // EXPORT COHORTE
  loadExportCohortes(): void {
    this.utilisateurService.allCohorts().subscribe({
      next: (cohortes) => {
        this.exportCohortes = cohortes;
      },
      error: (error) => {
        console.error(
          'Erreur lors du chargement des cohortes',
          error
        );
        this.exportCohortes = [];
      }
    });
  }

  // EXPORT - RESET
  resetExportFilters(): void {
    this.exportFlag = null;
    this.exportGender = null;
    this.exportCourseType = null;
    this.exportLabel = null;
    this.exportAgeRange = null;
    this.exportStatus = null;

    this.exportCountry = null;
    this.selectedExportCountry = this.exportCountries[0];

    this.exportRegion = null;
    this.selectedExportRegion = null;
    this.exportRegions = [];

    this.exportRegionOptions = [
      { name: 'Toutes les régions', isAll: true }
    ];

    this.selectedExportRegionOption = this.exportRegionOptions[0];
    this.loadingExportRegions = false;

    this.exportCertificateOptions = [];
    this.certifcateOption = [];
    this.exportCohorte = null
  }

  // EXPORT - MENU
  openExportMenu(): void {
    this.exportFlag =
      this.viewMode === 'CERTIFIED'
        ? 'CERTIFIED'
        : this.viewMode === 'ENHANCED'
          ? 'ENHANCED'
          : this.viewMode === 'INSERES'
            ? 'INSERES'
            : null;

    this.exportMenuOpen = true;
  }

  // EXPORT - TYPE PARCOURS
  onExportCourseTypeChange(): void {
    this.exportLabel = null;

    if (!this.exportCourseType) {
      this.certifcateOption = [];
      return;
    }

    this.utilisateurService
      .getAllCertificate(this.exportCourseType as CourseType)
      .subscribe({
        next: (res) => {
          this.certifcateOption = res;
        },
        error: (err) => {
          console.error(
            'Erreur lors du chargement des certificats',
            err
          );

          this.certifcateOption = [];
        }
      });
  }

  // EXPORT EXCEL
  exportStudents(isDistinct: boolean = false): void {
    if (this.exportLoading !== null) {
      return;
    }

    this.exportLoading = isDistinct ? 'distinct' : 'normal';

    this.utilisateurService
      .exportStudents(
        this.exportFlag,
        this.exportGender,
        this.exportCourseType,
        this.exportLabel,
        this.exportAgeRange,
        this.exportStatus,
        this.exportCountry,
        this.exportRegion,
        this.exportCohorte,
        isDistinct
      )
      .pipe(
        finalize(() => {
          this.exportLoading = null;
        })
      )
      .subscribe({
        next: (response) => {
          const blob = response.body;

          if (!blob) {
            return;
          }

          const contentDisposition = response.headers.get(
            'Content-Disposition'
          );

          let filename = 'export.xlsx';

          if (contentDisposition) {
            const match = contentDisposition.match(
              /filename="([^"]+)"/
            );

            if (match?.[1]) {
              filename = match[1];
            }
          }

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');

          link.href = url;
          link.download = filename;

          document.body.appendChild(link);
          link.click();
          link.remove();

          window.URL.revokeObjectURL(url);

          this.exportMenuOpen = false;
          this.resetExportFilters();
        },

        error: (error) => {
          console.error(
            'Erreur lors de l\'export Excel',
            error
          );
        }
      });
  }

  hasExportFilter(): boolean {
    return !!(
      this.exportFlag ||
      this.exportGender ||
      this.exportCourseType ||
      this.exportLabel ||
      this.exportAgeRange ||
      this.exportStatus ||
      this.exportCountry ||
      this.exportRegion ||
      this.exportCohorte
    );
  }
}